<template>
    <div class="d-flex mt-2 purple lighten-1 px-2" style="border-radius: 4px; min-height: 40px">
        <v-icon class="mr-2" color="main">
            mdi-flash-outline
        </v-icon>
        <div class="d-flex align-center">
            <div class="body-2 mr-2">{{ $t("Send email") }}</div>
            <div test-id="task-email-days-select" class="my-auto" :class="showOnText ? 'mr-2' : 'mr-1'">
                <ComboboxDropdown
                    :items="automationDays"
                    :selected="automationDays.filter(x => x.days === selectedDays)"
                    name-key="text"
                    value-key="days"
                    :show-selected-first="false"
                    dense-top
                    :deselect="false"
                    :searchable="false"
                    :menu-props="{
                        'open-on-hover': false,
                    }"
                    @input="$emit('updateSelectedDays', $event.days)"
                />
            </div>
            <div v-if="showOnText" class="body-2">{{ $t("on") }}</div>
            <div test-id="task-email-trigger-select" class="my-auto" :class="showOnText ? 'ml-2' : 'ml-1'">
                <ComboboxDropdown
                    :items="TASK_AUTOMATION_TRIGGERS()"
                    :selected="TASK_AUTOMATION_TRIGGERS().filter(x => x.type === selectedTrigger)"
                    name-key="text"
                    value-key="type"
                    show-selected-first
                    dense-top
                    :deselect="false"
                    :searchable="false"
                    :menu-props="{
                        'open-on-hover': false,
                    }"
                    @input="updateSelectedTrigger"
                />
            </div>
        </div>
        <div class="ml-auto my-auto">
             <icon-button
                v-if="canRemove"
                @click="$emit('removeAutomation')"
            >
                mdi-delete
            </icon-button>
        </div>
    </div>
</template>

<script>
import PersonAvatar from "../../../components/PersonAvatar";
import { $t } from "@/i18n";
import Vue from "vue"
import { ref, computed } from "@vue/composition-api";
import { TASK_AUTOMATION_DAYS, TASK_AUTOMATION_TRIGGERS, TASK_AUTOMATION_TRIGGER_TYPE } from "@/helpers/constants";
import ComboboxDropdown from "../../../components/ComboboxDropdown";

export default {
    name: "TaskAddEmailControlHeader",
    components: {
        ComboboxDropdown,
        PersonAvatar
    },
    props: {
        selectedDays: {
            required: true,
            type: Number
        },
        selectedTrigger: {
            required: true,
            type: String
        },
        canRemove: {
            required: true,
            type: Boolean
        }
    },
    setup (props, ctx) {
        const automationDays = computed(() => {
            return props.selectedTrigger === TASK_AUTOMATION_TRIGGER_TYPE.FINISHED ?
                TASK_AUTOMATION_DAYS().filter(x => x.days >= 0) :
                TASK_AUTOMATION_DAYS()
        })

        const updateSelectedTrigger = async (e) => {
            ctx.emit('updateSelectedTrigger', e.type)

            await Vue.nextTick()

            if (!automationDays.value.find(x => x.days === props.selectedDays)) {
                ctx.emit('updateSelectedDays', 0)
            }
        }

        const showOnText = computed(() => props.selectedDays === 0)

        return {
            automationDays,
            updateSelectedTrigger,
            TASK_AUTOMATION_TRIGGERS,
            showOnText
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input.v-text-field {
    width: 160px !important;
    background-color: var(--v-white-base) !important;

    .v-input__slot {
        border: 0 !important;
        min-height: 26px !important;
        margin-bottom: 0 !important;

        .v-input__append-inner {
            margin-top: auto !important;
            margin-bottom: auto !important;
        }

        fieldset {
            background-color: var(--v-purple-lighten1) !important;
            opacity: 0.5;
            border: 0 !important;
        }

        input {
            cursor: pointer;
            max-height: 26px;
        }
    }
}
</style>